import React from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { Button, message } from "antd";

import Language from "../../language/language";
import InvitationCode from "../../common/invitationCode";
import Modal from "../../modal/modal";
import { $const } from "../../../helper";
import KvItem from "./kvItem";
import CollegeAvatars from "./collegeAvatars";
import TeamInfoTabs from "./teamInfoTabs";
import CollectionProcess from "./collectionProcess";

import "../stylesheets/teamInfo.scss";

@inject("teamStore", "languageStore", "commonStore")
@withRouter
@observer
export default class TeamInfo extends React.Component {
  state = {
    changeInvitationModal: false,
    schoolsInfo: null
  };

  componentDidMount() {
    this.fetchSchoolsInfo();
  }

  // 通过teamid获取学校信息
  fetchSchoolsInfo = () => {
    if (this.props.teamStore && this.props.teamStore.teamInfo && this.props.teamStore.teamInfo.id) {
      this.props.teamStore
        .getSchoolsInfo(this.props.teamStore.teamInfo.id)
        .then(() => {
          this.setState({
            schoolsInfo: this.props.teamStore.schoolsInfo
          });
        })
        .catch(err => {
          console.log(err);
          message.error("获取学校信息失败，请刷新页面重试。");
        });
    }
  };

  changeInvitationCode = () => {
    this.props.teamStore.changeInvitationCode(this.props.info.id);
    this.closeChangeInvitationModal();
  };

  showChangeInvitationModal = () => {
    this.props.commonStore.gTag("event", "changeInvitationCode", {
      pageName: "gameApplyInfo",
      buttonName: "更换邀请码"
    });
    this.setState({
      changeInvitationModal: true
    });
  };

  closeChangeInvitationModal = () => {
    this.setState({
      changeInvitationModal: false
    });
  };

  getMemberNum = teamInfo => {
    let num = 0;
    if (teamInfo && teamInfo.gteamMembers && teamInfo.gteamMembers.nodes) {
      num = teamInfo.gteamMembers.nodes.length;
    }
    return num;
  };

  render() {
    const teamInfo = this.props.info;
    const lang = this.props.languageStore.lang;
    const schoolsInfo = this.state.schoolsInfo;
    // 队伍tag
    const teamTags =
      teamInfo.college && teamInfo.college.tags && teamInfo.college.tags[0]
        ? teamInfo.college.tags[0]
        : "";
    const currentTeamIsSpecialGame = this.props.teamStore.currentTeamIsSpecialGame;
    const showCollectionStage = this.props.teamStore.showCollectionStage;

    return (
      <div className="team-info">
        <div className="team-info-box">
          {/* 战队基础信息 */}
          <div className="team-info-box__info">
            <div className="title">
              <span>{teamInfo.name}</span>
              {teamInfo.zoneId && teamInfo.zone && teamInfo.zone[lang] ? (
                <span className="zone">{teamInfo.zone[lang]}</span>
              ) : null}
            </div>
            {/* 报名号 */}
            {teamInfo.gameData && teamInfo.gameData.code ? (
              <KvItem vskey="REGISTRATION_CODE" value={teamInfo.gameData.code} />
            ) : null}
            {/* 参赛项目 */}
            {teamInfo.gevent && teamInfo.gevent.titleUuidI18n[lang] ? (
              <KvItem vskey="ENTRY_PROJECT" value={teamInfo.gevent.titleUuidI18n[lang]} />
            ) : null}
            {/* 队伍类型 */}
            {teamTags ? (
              <KvItem vskey="GROUP_TYPE" value={teamTags[this.props.languageStore.lang]} />
            ) : null}
            {/* 当前人数（非队长展示） */}
            {!teamInfo.isCaptain ? (
              <KvItem vskey="NOW_MEMBER_NUM" value={this.getMemberNum(teamInfo)} />
            ) : null}
            {/* 队长和副队长都可以获取邀请码并更新 */}
            {!currentTeamIsSpecialGame && (teamInfo.isCaptain || teamInfo.isSubCaptain) ? (
              <div className="code-info">
                <div className="sub-title">
                  <Language resource="YOU_INVITATION_CODE" />
                  {": "}
                </div>
                <InvitationCode code={teamInfo.inviteCode} />
                {teamInfo.status !== $const.TEAM_STATUS.LOCKED ? (
                  <div className="change-code spe-link" onClick={this.showChangeInvitationModal}>
                    <Language resource="CHANGE_INVITATION_CODE" />
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
          {/* 战队学校校徽 */}
          {schoolsInfo ? <CollegeAvatars info={schoolsInfo} /> : null}
        </div>
        {currentTeamIsSpecialGame && showCollectionStage ? <CollectionProcess /> : null}
        <TeamInfoTabs isEditing={this.props.isEditing} schoolsInfo={schoolsInfo} />
        <Modal
          title={<Language resource="CHANGE_INVITATION_CODE" />}
          state={this.state.changeInvitationModal}
          close={this.closeChangeInvitationModal}
          className="team-info__changeCode"
        >
          <div className="team-info__changeCode--sub-title">
            <Language resource="INVITATION_TIP"></Language>
          </div>
          <div className="team-info__changeCode--change">
            <Button type="primary" onClick={this.changeInvitationCode}>
              <Language resource="CHANGE"></Language>
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/index.js